import './App.css';


export function App() {
  return (
      <div className="main-page" >
        <div className="noise"></div>
        <h1>we are growing gills</h1>
        <p>Watch this space. New things coming sooner than you think.</p>
        <a className="button" target="_blank" rel="noreferrer" href="https://93353c9e.sibforms.com/serve/MUIFANTBBwsAEG1PsXwC_dAz7lZSOtjwWdh3veh4k1NdcdcxZewf77lbuKHZYMQGhHUukhQxksoY27UlQBJyUNFmycCaUmEPzLRJDi2lI-jqoIh-pY1uSFUktodbxj03XLz1sCb9lRpLtDXYCJ316Ceq3XGaFyLLapwd5M3HaAqR_obu0RgaQMXD1mBBNqsYhcm-u_oH88rmUOytZQ==" >ATWC Playtest</a>

      </div>
  );
}
